module.exports = __webpack_public_path__ + "static/mind-fullness-4156953e03d41adba5f23c509b00a7ac.svg";